import request from '@/utils/request'
import { PROXY } from '@/constants'

export function xml({ hotel_id, hall_id = 0, pano_id = '', loading = '', compare = '' }) {
  // eslint-disable-next-line 
  return `${PROXY}/api/pano/v2/hotel/${hotel_id}/hall/${hall_id}/pano?pano_id=${pano_id}&loading=${loading}&compare=${compare}`
}

export function panoInfo({ hall_id, hotel_id, bar_height, is_old }) {
  return request({
    url: `/api/app-renren/v1/pano/hall/${hall_id}`,
    params: { bar_height, hotel_id, is_old },
  })
}
